"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = require("draft-js");

var leaveList = function leaveList(editorState) {
  var contentState = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var currentBlock = contentState.getBlockForKey(key);
  var type = currentBlock.getType();
  return _draftJs.RichUtils.toggleBlockType(editorState, type);
};

exports.default = leaveList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-markdown-plugin/lib/modifiers/leaveList.js
// module id = 266
// module chunks = 0